module.exports = __webpack_public_path__ + "img/breadcrumbs-doctors.eea92283.jpg";